import * as React from "react";
import {useState} from "react";
import PhoneInput, {isPossiblePhoneNumber,parsePhoneNumber} from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import {Input} from 'antd'

let InternationalPhoneContext = React.createContext(null);

const useInternationalPhone= () => {
    return React.useContext(InternationalPhoneContext);
}
const InputHandler = ({...props}) => {

    const {country, setCountry} = useInternationalPhone();
    console.log('props', props)
    return <Input {...props} addonBefore={country} />
}
const InternationalPhoneInput = ({value, onChange, ...props}) => {
    const [country, setCountry] = useState('US');

    const contextValue = {
        country,
        setCountry
    }

    return (
        <InternationalPhoneContext.Provider value={contextValue}>
        <div className="flex items-center relative">
            <PhoneInput
                {...props}
                international
                withCountryCallingCode
                countryCallingCodeEditable={false}
                defaultCountry="US"
                // initialValueFormat="national"
                value={value}
                onCountryChange={country => setCountry(country) }
                onChange={e => {

                    onChange(e)
                    try {
                        let regionNames = new Intl.DisplayNames(['en'], {type: 'region'});
                        // let regionNames = new Intl.DisplayNames(['en'], {type: 'region'});
                        // setCountry(getCountryCallingCode(parsePhoneNumber(e)?.countryCallingCode))
                        //
                        console.log('onChangeIntPhoneInput', e, regionNames.of(parsePhoneNumber(e).country));
                    }catch (e) {

                    }
                }}
                error={value ? ((TB.isString(value) && value?.length > 0 && isPossiblePhoneNumber(value)) ? undefined : 'Invalid phone number') : 'Phone number required'}/>
        </div>
        </InternationalPhoneContext.Provider>
    );
};
export default InternationalPhoneInput